import classNames from 'classnames';
import { generatePath } from 'react-router-dom';

import { Title } from '@ui/Title';
import { Link } from '@ui/Link';
import * as legacyUrls from '@legacyUrls';

import s from './TagGroupCrossLinking.sss';

type Tag = {
  id: number
  slug: string
  anchorTitle: string
};

type Group = {
  id: number
  name: string
  weight?: number | null
  tags: Tag[]
};

export type TagGroupCrossLinkingProps = {
  groups: Group[]
  className?: string
};

export const TagGroupCrossLinking: React.FC<TagGroupCrossLinkingProps> = ({
  groups,
  className,
}) => (
  <div className={classNames(s.root, className)}>
    {
      groups.map(
        (group) => (
          <div
            key={group.id}
            className={s.group}
          >
            <Title type="h5" className={s.title}>
              {group.name}
            </Title>

            <div className={s.tags}>
              {
                group.tags.map(
                  (tag) => (
                    <Link
                      key={tag.id}
                      className={s.link}
                      theme="black"
                      to={generatePath(legacyUrls.tag, { slug: tag.slug })}
                    >
                      {tag.anchorTitle}
                    </Link>
                  ),
                )
              }
            </div>
          </div>
        ),
      )
    }
  </div>
);
